// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__ssBeE","info":"UpdateTermsInfo_info__38heC"};